export default "__VITE_ASSET__BdmoR6Nm__"